import React from "react";

import NotFoundBlock from "../components/NotFoundBlock";

const NotFound: React.FC = () => <NotFoundBlock />;

export default NotFound;
